<template>
   <div>
    <div>
        <div class="clearfix table-tools">
        <div class="search">
            <a-form layout='inline' @submit="searchList">
            <a-form-item>
                <a-tooltip placement="topLeft" >
                <template slot="title">
                    <span>时间筛选</span>
                </template>
                <a-range-picker
                    :ranges="rangesData"
                    :value='rangesValue'
                    :disabled-date="disabledDate" :allowClear="false"
                    :default-value="[moment(paramsData.stock_date,'YYYY-MM-DD'),moment(paramsData.end_date,'YYYY-MM-DD')]"  style="width: 240px"
                    @change="(date, dateString)=>onChange(date, dateString,1)" />
                </a-tooltip>
            </a-form-item>

            <a-form-item>
                <a-select
                    v-model="paramsData.shape_name"
                    placeholder="形态名称"
                    style="width: 250px;"
                    allowClear
                    showSearch
                    :filterOption="filterOption"
                >
                    <a-select-option v-for="(name, key) in patternNames" :key="key" :value="key">
                        {{ name }} ({{ key }})
                    </a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item>
                <a-button type="primary" html-type="submit" @click="searchList">搜索</a-button>
            </a-form-item>

            </a-form>
        </div>
        </div>
        <div class="table">
        <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>

        <div class="table-container">
            <a-table size="small" :pagination="false" :bordered='false' rowKey="id"
                :columns="columns" :dataSource="list" @change="handleChange" :scroll="{ x: 'max-content' }">
            <template slot="index" slot-scope="text, record , index">
            <span>{{(index+1)}}</span>
            </template>

            <template slot="pattern_name" slot-scope="text, record , index">
                <span>{{text}}</span>
            </template>

            <template slot="pattern_name_cn" slot-scope="text, record , index">
                <span>{{text}}</span>
            </template>

            <template slot="total_signals" slot-scope="text, record , index">
                <span>{{text}}</span>
            </template>

            <template slot="bullish_signals" slot-scope="text, record , index">
                <span :style="{ color: 'red' }">{{ text }}</span>
            </template>

            <template slot="bearish_signals" slot-scope="text, record , index">
                <span :style="{ color: 'green' }">{{ text }}</span>
            </template>

            <template slot="bullish_ratio" slot-scope="text, record , index">
                <span>{{ (text * 100).toFixed(1) }}%</span>
            </template>

            <template slot="stock_code" slot-scope="text, record , index">
                <span @click="copyStockCode(text)" style="cursor: pointer; color: #1890ff;">{{text}}</span>
            </template>

            <template slot="stock_name" slot-scope="text, record , index">
                <span>{{text}}</span>
            </template>

            <template slot="stock_zhangdiefu" slot-scope="text, record , index">
                <span :style="{ color: text > 0 ? 'red' : text < 0 ? 'green' : 'black' }">{{ text+'%'}}</span>
            </template>

            <template slot="trade_date" slot-scope="text, record , index">
                <span>{{text}}</span>
            </template>

            <template slot="signal_direction" slot-scope="text, record , index">
                <span :style="{ color: text === '看涨(↑)' ? 'red' : 'green' }">{{ text }}</span>
            </template>

            <template slot="signal_strength" slot-scope="text, record , index">
                <span>{{ text }}</span>
            </template>

            </a-table>
        </div>
        </div>
    </div>
   </div>
</template>

<script>
import moment from 'moment'
import vueElementLoading from 'vue-element-loading'
export default {
    name: 'shapeListGrid',
    components: {
        vueElementLoading
    },
    data() {
        return {
            loading: false,
            list: [],
            paramsData: {
                stock_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
                shape_name: 'CDLHARAMI'
            },
            patternNames: {
                'CDL2CROWS': '两只乌鸦',
                'CDL3BLACKCROWS': '三只乌鸦',
                'CDL3INSIDE': '三内部上涨下跌',
                'CDL3LINESTRIKE': '三线打击',
                'CDL3OUTSIDE': '三外部上涨下跌',
                'CDL3STARSINSOUTH': '南方三星',
                'CDL3WHITESOLDIERS': '三白兵',
                'CDLABANDONEDBABY': '弃婴',
                'CDLADVANCEBLOCK': '前进受阻',
                'CDLBELTHOLD': '看跌捉腰带',
                'CDLBREAKAWAY': '脱离',
                'CDLCLOSINGMARUBOZU': '收市光头光脚',
                'CDLCONCEALBABYSWALL': '藏婴吞没',
                'CDLCOUNTERATTACK': '反击线',
                'CDLDARKCLOUDCOVER': '乌云压顶',
                'CDLDOJI': '十字星',
                'CDLDOJISTAR': '十字星',
                'CDLDRAGONFLYDOJI': '蜻蜓十字',
                'CDLENGULFING': '吞没',
                'CDLEVENINGDOJISTAR': '黄昏十字星',
                'CDLEVENINGSTAR': '黄昏之星',
                'CDLGAPSIDESIDEWHITE': '向上/下跳空并列阳线',
                'CDLGRAVESTONEDOJI': '墓碑十字',
                'CDLHAMMER': '锤头',
                'CDLHANGINGMAN': '上吊线',
                'CDLHARAMI': '孕线',
                'CDLHARAMICROSS': '十字孕线',
                'CDLHIGHWAVE': '风高浪大线',
                'CDLHIKKAKE': '梯底',
                'CDLHOMINGPIGEON': '家鸽',
                'CDLIDENTICAL3CROWS': '三胞胎乌鸦',
                'CDLINNECK': '颈内线',
                'CDLINVERTEDHAMMER': '倒锤头',
                'CDLKICKING': '看涨/看跌捉腰带',
                'CDLKICKINGBYLENGTH': '看涨/看跌捉腰带线',
                'CDLLADDERBOTTOM': ' ladderbottom',
                'CDLLONGLEGGEDDOJI': '长腿十字',
                'CDLLONGLINE': '长蜡烛线',
                'CDLMARUBOZU': '光头光脚',
                'CDLMATCHINGLOW': '匹配低位',
                'CDLMATHOLD': '看涨/看跌捉腰带线',
                'CDLMORNINGDOJISTAR': '早晨十字星',
                'CDLMORNINGSTAR': '早晨之星',
                'CDLONNECK': '颈上线',
                'CDLPIERCING': '刺透线',
                'CDLRICKSHAWMAN': '黄包车夫',
                'CDLRISEFALL3METHODS': '上升/下降三法',
                'CDLSEPARATINGLINES': '分离线',
                'CDLSHOOTINGSTAR': '流星',
                'CDLSHORTLINE': '短蜡烛线',
                'CDLSPINNINGTOP': '陀螺线',
                'CDLSTALLEDPATTERN': '停滞模式',
                'CDLSTICKSANDWICH': '三明治',
                'CDLTAKURI': '探水竿',
                'CDLTASUKIGAP': '跳空并列阴阳线',
                'CDLTHRUSTING': '插入线',
                'CDLTRISTAR': '三星',
                'CDLUNIQUE3RIVER': '奇特三河床',
                'CDLUPSIDEGAP2CROWS': '向上跳空两只乌鸦',
                'CDLXSIDEGAP3METHODS': '上升/下降三法'
            },
            rangesData: {
                '今天': [moment(), moment()],
                '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                '最近7天': [moment().subtract(6, 'days'), moment()],
                '最近30天': [moment().subtract(29, 'days'), moment()],
                '本月': [moment().startOf('month'), moment().endOf('month')],
                '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            rangesValue: [moment(), moment()],
            columns: [
                { title: '#', width: 50, scopedSlots: { customRender: 'index' }, fixed: 'left' },
                { title: '形态名称', dataIndex: 'pattern_name', width: 150, scopedSlots: { customRender: 'pattern_name' } },
                { title: '形态中文名', dataIndex: 'pattern_name_cn', width: 150, scopedSlots: { customRender: 'pattern_name_cn' } },
                { title: '总信号数', dataIndex: 'total_signals', width: 100, scopedSlots: { customRender: 'total_signals' } },
                { title: '看涨信号', dataIndex: 'bullish_signals', width: 100, scopedSlots: { customRender: 'bullish_signals' } },
                { title: '看跌信号', dataIndex: 'bearish_signals', width: 100, scopedSlots: { customRender: 'bearish_signals' } },
                { title: '看涨比例', dataIndex: 'bullish_ratio', width: 100, scopedSlots: { customRender: 'bullish_ratio' } },
                { title: '股票代码', dataIndex: 'stock_code', width: 100, scopedSlots: { customRender: 'stock_code' } },
                { title: '股票名称', dataIndex: 'stock_name', width: 120, scopedSlots: { customRender: 'stock_name' } },
                { title: '涨跌幅', dataIndex: 'stock_zhangdiefu', width: 100, scopedSlots: { customRender: 'stock_zhangdiefu' } },
                { title: '交易日期', dataIndex: 'trade_date', width: 120, scopedSlots: { customRender: 'trade_date' } },
                { title: '信号方向', dataIndex: 'signal_direction', width: 100, scopedSlots: { customRender: 'signal_direction' } },
                { title: '信号强度', dataIndex: 'signal_strength', width: 100, scopedSlots: { customRender: 'signal_strength' } },
            ]
        }
    },
    created() {
        this.getList()
    },
    methods: {
        moment,
        // 获取列表数据
        async getList() {
            this.loading = true
            let res = await this.$store.dispatch('enterpriseLabStockShapeListAction', {data:this.paramsData})
            this.loading = false
            
            if (res && res.data) {
                // 处理返回的数据，将每个股票的形态信息展开为多行
                const result = []
                let data = res.data
                
                // 检查数据结构，如果是对象且包含shapes属性，则使用shapes数组
                if (data && typeof data === 'object' && !Array.isArray(data) && data.shapes) {
                    data = data.shapes
                }
                
                // 遍历每个股票数据
                if (Array.isArray(data)) {
                    data.forEach(stock => {
                        // 遍历该股票的所有形态
                        if (stock.shapes && typeof stock.shapes === 'object') {
                            for (const pattern in stock.shapes) {
                                const signalValue = stock.shapes[pattern]
                                let signalDirection = ''
                                let signalStrength = ''
                                
                                // 根据信号值确定信号方向
                                if (signalValue === "100") {
                                    signalDirection = '看涨(↑)'
                                    signalStrength = '强'
                                } else if (signalValue === "-100") {
                                    signalDirection = '看跌(↓)'
                                    signalStrength = '强'
                                } else {
                                    signalDirection = '中性(→)'
                                    signalStrength = '弱'
                                }
                                
                                // 添加到结果中
                                result.push({
                                    id: `${stock.stock_code}_${stock.stock_date}_${pattern}`,
                                    pattern_name: pattern,
                                    pattern_name_cn: this.getPatternChineseName(pattern),
                                    total_signals: 1, // 单个信号
                                    bullish_signals: signalValue === "100" ? 1 : 0,
                                    bearish_signals: signalValue === "-100" ? 1 : 0,
                                    bullish_ratio: signalValue === "100" ? 1 : 0,
                                    stock_code: stock.stock_code,
                                    stock_name: stock.stock_name || '',
                                    stock_zhangdiefu: stock.stock_zhangdiefu || 0,
                                    trade_date: stock.stock_date,
                                    signal_direction: signalDirection,
                                    signal_strength: signalStrength
                                })
                            }
                        }
                    })
                }
                
                this.list = result
            } else {
                this.$message.error('获取数据失败')
            }
        },
        // 搜索
        searchList(e) {
            e.preventDefault()
            this.getList()
        },
        // 表格变化
        handleChange(pagination, filters, sorter) {
            // 这里可以添加排序、筛选等逻辑
        },
        // 日期变化
        onChange(date, dateString, type) {
            this.paramsData.stock_date = dateString[0]
            this.paramsData.end_date = dateString[1]
            this.rangesValue = date
        },
        // 禁用今天之后的日期
        disabledDate(current) {
            return current && current > moment().endOf('day')
        },
        // 复制股票代码
        copyStockCode(stockCode) {
            // 创建一个临时的输入框元素
            const tempInput = document.createElement('input')
            tempInput.value = stockCode
            document.body.appendChild(tempInput)
            tempInput.select()
            
            try {
                // 执行复制命令
                const successful = document.execCommand('copy')
                document.body.removeChild(tempInput)
                
                if (successful) {
                    this.$message.success(`股票代码 ${stockCode} 已复制到剪贴板`)
                } else {
                    this.$message.error('复制失败，请手动复制')
                }
            } catch (err) {
                document.body.removeChild(tempInput)
                this.$message.error('复制失败，请手动复制')
            }
        },
        // 格式化数字
        formatNumber(num) {
            if (num === null || num === undefined) return ''
            return Number(num).toFixed(2)
        },
        // 获取形态的中文名称
        getPatternChineseName(pattern) {
            return this.patternNames[pattern] || pattern
        },
        // 下拉框搜索过滤方法
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.cell-content {
  white-space: normal; /* 允许换行 */
  word-wrap: break-word; /* 长单词换行 */
}

.table-container {
  overflow-x: auto; /* 启用水平滚动 */
  width: 100%;
  
  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    height: 8px; /* 水平滚动条高度 */
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
    
    &:hover {
      background: #a8a8a8;
    }
  }
}

/* 确保表格在容器中正确显示 */
.ant-table {
  min-width: 100%;
  
  .ant-table-body {
    overflow-x: auto !important;
  }
}
</style>